import { render, staticRenderFns } from "./chat-indice-artefatos-completa.vue?vue&type=template&id=3d68a9c4&scoped=true&"
import script from "./chat-indice-artefatos-completa.vue?vue&type=script&lang=js&"
export * from "./chat-indice-artefatos-completa.vue?vue&type=script&lang=js&"
import style0 from "./chat-indice-artefatos-completa.vue?vue&type=style&index=0&id=3d68a9c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d68a9c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d68a9c4')) {
      api.createRecord('3d68a9c4', component.options)
    } else {
      api.reload('3d68a9c4', component.options)
    }
    module.hot.accept("./chat-indice-artefatos-completa.vue?vue&type=template&id=3d68a9c4&scoped=true&", function () {
      api.rerender('3d68a9c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-indice-artefatos/chat-indice-artefatos-completa.vue"
export default component.exports